// UI-only fence. The server still owns authorization, upload validation and
// optimistic concurrency. A late confirmed save must not replace another job.
export function acceptsPrivateReferenceReadback({selectedId,current,expected,updated}) {
  if(!current||!expected||!updated)return false
  const id=String(expected.id||'')
  if(!id||String(selectedId)!==id||String(current.id)!==id||String(updated.id)!==id)return false
  if(current.artworkRevision!==expected.artworkRevision||updated.artworkRevision!==expected.artworkRevision)return false
  for(const job of [current,updated]){
    if(job.artworkEngine?.revision!==expected.artworkEngine?.revision)return false
    if(job.artworkEngine?.specFingerprint!==expected.artworkEngine?.specFingerprint)return false
  }
  if(![current.version,expected.version,updated.version].every(Number.isSafeInteger))return false
  return current.version>=expected.version&&updated.version>current.version
}
